<template>
    <v-container fluid>
    <field-form id="pfid1628066356"  @save="save" :saving="saving"  v-if="item">
      <h2 class="text-h4">{{ $t('customizations.title') }}</h2>
      <p>{{$t('customizations.text')}}</p>
      <v-card class="my-3">
      <v-card-title>{{$t('customizations.unsubscribe.title')}}</v-card-title>
      <v-card-text>
      <p>{{$t('customizations.unsubscribe.text')}}</p>
      <v-text-field 
      id="pfid1628066729"   
      v-model="unsubscribeSetup.title" 
      :label="$t('customizations.unsubscribe.fields.title')"
      prepend-icon="$tab"
      placeholder="DreamROI Unsubscribe"
      style="max-width:800px"
      class="pr-3"
      clearable
      />
      <v-text-field  
      id="pfid1628066750" 
      v-model="unsubscribeSetup.heading" 
      :label="$t('customizations.unsubscribe.fields.heading')"
      prepend-icon="$heading"
      placeholder="Thank you"
      style="max-width:800px"
      class="pr-3"
      clearable
      />
      <v-textarea 
      id="pfid1628067255"  
      v-model="unsubscribeSetup.text" 
      prepend-icon="$text" 
      :label="$t('customizations.unsubscribe.fields.text')"
      style="max-width:800px"
      class="pr-3"
      clearable
      />
      </v-card-text>
      <v-card-actions>
        <v-btn text color="primary" :href="unsubscribePreview" target="_blank"><v-icon left>$view</v-icon>{{$t('customizations.unsubscribe.preview')}}</v-btn>
      </v-card-actions>
      </v-card>
      
    </field-form>
    </v-container>
</template>
<script>
  import EntityForm from "@/mixins/entity-form"
  import Wizards from "@/mixins/wizards"
  import { mapGetters } from "vuex"
  export default {
    name: 'Customizations',
    mixins: [EntityForm, Wizards],
    data() {
      return {
          endpoint: 'domains',
          fields: {
            unsubscribeSetup: null
          },
          unsubscribeSetup: {
              title: null,
              heading: null,
              text: null
          }
      };
    },
    computed: {
      unsubscribePreview() {
        return `${this.trackerUrl}/unsubscribe/visitor/testEmail$${this.item?.id}/message/preview/`
      },
      ...mapGetters('ui', ['trackerUrl'])
    },
    methods: {
      prepareFields() {
        this.fields.unsubscribeSetup = this.unsubscribeSetup;
        return true;
      },
      afterFieldsLoad() {
        if(this.item.unsubscribeSetup) {
          Object.keys(this.item.unsubscribeSetup).forEach(k => {
            this.unsubscribeSetup[k] = this.item.unsubscribeSetup[k];
          })
        }
      }
    }
  }
</script>